import React from "react";

interface SkeletonProps {
  rows?: number;
  size?: "small" | "large";
  className?: string;
  avatar?: boolean;
  color?: string;
}

export default function Skeleton({
  rows = 1,
  size = "small",
  avatar = false,
  className = "",
  color = "bg-gray-300",
}: SkeletonProps) {
  const sizeClass = size === "large" ? "h-6" : "h-4 w-32";

  return (
    <div className={className}>
      <div className="my-2 flex animate-pulse flex-row items-center space-x-5">
        <div className="flex flex-row w-full space-x-2">
          {avatar && <div className={`w-12 ${color} h-12 rounded-full`} />}
          <div className="flex flex-col space-y-3 flex-grow">
            {Array.from({ length: rows }, (row, i) => (
              <div key={i} className={`${sizeClass} ${color} rounded-md`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
